const parseBoolean = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value !== 'string') return false;

  return ['true', '1', 'yes', 'on'].includes(value.toLowerCase());
};

const parseNumber = (value) => {
  if (typeof value === 'number') return value;
  const n = Number(value);
  return Number.isNaN(n) ? null : n;
};

const parseJSON = (value) => {
  if (typeof value === 'object') return value;
  if (typeof value !== 'string') return null;

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

class ConfigProcessor {
  #configMap;
 
  constructor(config, environ) {
    this.#configMap = {};
    if (config)
      Object.entries(config).forEach(([key, value]) => {
        const { default: defaultValue = null, parser = null, envKey = key } = value;
        const processedValue = ConfigProcessor.#getEnvValue(key, defaultValue, parser, envKey, environ);
        this.#configMap[key] = processedValue;
      });
  }
 
  static #getEnvValue(key, defaultValue, parser, envKey, environ) {
    if (typeof window.runtimeConfig !== 'undefined' && window.runtimeConfig !== null && key in window.runtimeConfig) return window.runtimeConfig[key];
    const metaEnvValue = environ[envKey];
    if (typeof metaEnvValue !== 'undefined') {
      if (parser) return parser(metaEnvValue);
      return metaEnvValue;
    }
    if (typeof defaultValue !== 'undefined') return defaultValue;
    return null;
  }
 
  getconfig() {
    return this.#configMap;
  }
 
  get(key) {
    return this.#configMap[key];
  }
}
 
export { ConfigProcessor, parseBoolean, parseNumber, parseJSON };
 
export default ConfigProcessor;
